import SalesAnalyticsDashboard from "./sales-analytics";

export default function FinanceAnalytics() {
  return <SalesAnalyticsDashboard />;
}
